export const CardDetails = [
  {
    id: 1,
    attribute: ['biller', 'billerCode', 'accountId'],
    label: {
      biller: 'Biller',
      billerCode: 'biller Code',
      accountId: 'Account ID',
    },
  },
  {
    id: 2,
    attribute: ['amount', 'fee', 'createdAt'],
    label: {
      amount: 'Amount',
      fee: 'Fee',
      createdAt: 'Created At',
    },
  },

  {
    id: 3,
    attribute: ['datePaid', 'updatedAt', ''],
    label: {
      datePaid: 'Date Paid',
      updatedAt: 'Date Updated',
    },
  },
];
